import 'css-chunksrc/client/scenes/projectStrategicAxes/projectStrategicAxesTable/styles.scss';export default {
  "projectStrategicAxes": "_projectStrategicAxes_10bto_1"
};